var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleform = function SvgSimpleform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M31.404 5.323H.532a.532.532 0 1 1 0-1.063h30.872a.531.531 0 1 1 0 1.063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M.532 21.29A.53.53 0 0 1 0 20.76V1.598C0 .717.716 0 1.597 0h28.742a1.6 1.6 0 0 1 1.597 1.598v9.58a.531.531 0 0 1-1.064 0v-9.58a.533.533 0 0 0-.533-.533H1.597a.533.533 0 0 0-.533.533V20.76c0 .293-.238.53-.532.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.307 26.614h5.322V25.55h-5.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M22.355 30.871H10.113a.531.531 0 1 1 0-1.063h1.065c.88 0 1.597-.717 1.597-1.596v-1.066a.533.533 0 0 1 1.064 0v1.066c0 .598-.199 1.151-.533 1.596h5.325a2.65 2.65 0 0 1-.534-1.596v-3.195a.532.532 0 1 1 1.065 0v3.195c0 .88.716 1.596 1.596 1.596h1.597a.532.532 0 1 1 0 1.063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.34 25.017H1.596a1.065 1.065 0 0 1-1.065-1.065v-1.596h30.872v1.596c0 .588-.476 1.065-1.065 1.065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M18.63 25.55H1.596C.717 25.55 0 24.834 0 23.952V20.76c0-.295.238-.533.532-.533h14.904a.532.532 0 1 1 0 1.064H1.064v2.661c0 .293.24.533.533.533h17.032a.532.532 0 1 1 0 1.065M6.92 12.775H3.725a.532.532 0 1 1 0-1.065h3.193a.533.533 0 0 1 0 1.065M14.371 8.517H3.726a.532.532 0 1 1 0-1.065h10.645a.533.533 0 0 1 0 1.065M14.371 10.646H3.726a.532.532 0 1 1 0-1.065h10.645a.533.533 0 0 1 0 1.065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99D6D2",
    d: "M25.549 13.308a6.92 6.92 0 0 0-6.92 6.92c0 1.637.573 3.142 1.527 4.328a6.918 6.918 0 0 0 11.248-5.394 6.9 6.9 0 0 0-1.526-4.329 6.9 6.9 0 0 0-4.33-1.525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M24.484 26.614c-4.109 0-7.451-3.342-7.451-7.452s3.342-7.452 7.451-7.452c1.44 0 2.835.412 4.037 1.188a.532.532 0 0 1-.578.895 6.34 6.34 0 0 0-3.459-1.018 6.394 6.394 0 0 0-6.387 6.387 6.395 6.395 0 0 0 6.387 6.388 6.395 6.395 0 0 0 6.069-8.385.533.533 0 0 1 1.011-.333c.247.75.372 1.534.372 2.33 0 4.11-3.343 7.452-7.452 7.452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M23.952 22.036h-.012a.54.54 0 0 1-.397-.192L20.88 18.65a.533.533 0 0 1 .82-.68l2.27 2.725 6.616-7.309a.532.532 0 0 1 .784.719l-7.026 7.758a.54.54 0 0 1-.393.173"
  }))));
};
export default SvgSimpleform;